import { ColumnInfo, ColumnInfoList, DisplaySetting } from 'components/shared/display_setting'
import { Flex } from 'components/shared/flex'
import { TableCell } from 'components/shared/widget'
import { TaskGroup } from 'entities/task_group'
import { ReactNode, useMemo } from 'react'
import { ProgressBar } from 'react-bootstrap'
import { Form } from 'utils/hooks'
import { toDateTimeText } from 'utils/util'

export const taskGroupColumnInfoList = (form?: Form<Record<string, unknown>>): ColumnInfoList => {
    return {
        tableName: '',
        values: [
            { name: 'ID', th: true, width: 50, form: form, orderAttr: 'task_group_id', searchType: { name: 'id', type: 'multiple_text' } },
            { name: 'ユーザー', th: true, width: 150, form: form, orderAttr: 'task_group_user_id' },
            { name: '作成日', th: true, minWidth: 200, form: form, orderAttr: 'task_group_created_at', searchType: { name: 'created_at', type: 'date' } },
            { name: 'タスク数', th: true, width: 200, align: 'center' },
        ],
    }
}

export type TaskGroupTableDataProps = {
    taskGroup?: TaskGroup
    displaySetting: DisplaySetting
}

export const TaskGroupTableData = ({ taskGroup, displaySetting }: TaskGroupTableDataProps): JSX.Element => {
    if (!taskGroup) {
        return (
            <>
                {displaySetting.columnInfoList.values.map((_: ColumnInfo, index: number) => {
                    if (displaySetting.hiddenList.includes(index)) {
                        return <></>
                    } else {
                        return <TableCell key={index}></TableCell>
                    }
                })}
            </>
        )
    }

    const createCells = useMemo(() => {
        return (
            <>
                <TableCell>{taskGroup.id}</TableCell>
                <TableCell>{taskGroup.user?.fullName}</TableCell>
                <TableCell>{toDateTimeText(taskGroup.createdAt)}</TableCell>
                <TableCell align="center">
                    {(() => {
                        const completeCount = taskGroup.taskSets?.filter((ts) => !!ts.completedAt).length
                        const total = taskGroup.taskSets?.length
                        const rate = Math.round(((completeCount ?? 1) / (total ?? 1)) * 100)
                        return (
                            <Flex alignItems="center">
                                <div style={{ flexGrow: 1, marginRight: 0 }}>
                                    <ProgressBar variant="primary" now={rate} label={`${rate}%`}></ProgressBar>
                                </div>
                                <div style={{ width: 80, textAlign: 'center' }}>
                                    <div>
                                        {completeCount} / {total}
                                    </div>
                                </div>
                            </Flex>
                        )
                    })()}
                </TableCell>
            </>
        )
    }, [displaySetting.hiddenList])

    return createCells.props.children.filter((_: ReactNode, index: number) => !displaySetting.hiddenList?.includes(index)).map((cell: ReactNode) => cell)
}
